import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
  useState,
} from "react";
import { menuInfo } from "@shared/type/CommonType";
import { global } from "@shared/libs/Global";
import {
  applyAutoSlip,
  CalAm,
  getInitFormData,
} from "@shared/utils/CommonUtils";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { showDialog } from "@widgets/CommonDialog";
import { dateToString } from "@shared/utils/DateUtils";
import { showResizablePopupModal } from "@widgets/CommonModal";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";
import SearchPanel from "@widgets/SearchPanel";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnGrid from "@shared/components/GridV2/SnGrid";
import { SnButton } from "@shared/components/SnButton";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import SN_MTL_SCT_REG_002_POP_001 from "./SN_MTL_SCT_REG_002_POP_001";
import { SnTabHeader } from "@shared/components/SnTabHeader";
import SnTab from "@shared/components/SnTab";
import { RowNode } from "ag-grid-community";

interface Props {
  Menuprops: menuInfo;
}

const SN_MTL_SCT_REG_002 = forwardRef(({ Menuprops }: Props, ref) => {
  const { userInfo } = global();

  const searchRef = useRef<any>(null);
  const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
    grid1: React.createRef(),
    grid2: React.createRef(),
    grid3: React.createRef(),
  });

  const [formData, setFormData] = useState<any>();
  const [formControlData, setFormControlData] = useState<any[]>([]);
  const [columns, setColums] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });
  const [dataSources, setDataSources] = useState<any>({
    grid1: [],
    grid2: [],
    grid3: [],
  });

  const [selectedDocu, setSelectedDocu] = useState<string>("");
  const [focusedIndex, setFocusedIndex] = useState();

  useEffect(() => {
    const fetchform = async () => {
      try {
        const rtn: any = await getInitFormData();
        setFormControlData(rtn.formControlData);
        setFormData((prev: any) => ({
          ...(rtn.formData || {}),
          ...(prev || {}),
        }));
        setColums({
          grid1: rtn.grid.grid1,
          grid2: rtn.grid.grid2,
          grid3: rtn.grid.grid3,
        });
      } catch (error) {}
    };
    fetchform();
  }, []);

  useImperativeHandle(ref, () => ({
    onSearch,
    onInsert,
    onDelete,
    onSave,
  }));

  const onSearch = async () => {
    const modifiedRowsH = gridRefs.current["grid1"].current.getChange();
    const modifiedRowsL1 = gridRefs.current["grid2"].current.getChange();
    const modifiedRowsL2 = gridRefs.current["grid3"].current.getChange();
    if (
      modifiedRowsH.modifiedRowcount > 0 ||
      modifiedRowsL1.modifiedRowcount > 0 ||
      modifiedRowsL2.modifiedRowcount > 0
    ) {
      const confirm = await showDialog(
        "confirm",
        "수정된 내용이 있습니다. 저장하시겠습니까?"
      );
      if (confirm) {
        const isSaved: any = await onSave();
        if (!isSaved) return;
      }
    }

    try {
      const params = {
        id: "sn_mtl_sct_reg_002_01",
        params: searchRef.current.getFormdata(),
      };

      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      const data: any = await fnGetDataSet(params);
      setDataSources({
        grid1: data[0],
        grid2: data[1] || [],
        grid3: data[2] || [],
      });
    } catch (error: any) {}
  };

  const onInsert = () => {
    try {
      gridRefs.current["grid1"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow1 = (): any => {
    try {
      const modifiedRowsH =
        gridRefs.current["grid1"].current.getChange().insert;
      if (modifiedRowsH.length > 0) {
        showDialog("alter", "진행중인 건을 먼저 처리하세요.");
        return false;
      }

      const searchInfo = searchRef.current.getFormdata();
      const today = dateToString(new Date());
      return {
        cd_firm: userInfo?.cd_firm,
        cd_biz: searchInfo?.cd_biz,
        dt_io: today,
        cd_emp: userInfo?.cd_emp,
        nm_emp: userInfo?.nm_emp,
        cd_dept: userInfo?.cd_dept,
        nm_dept: userInfo?.nm_dept,
        cd_gp: userInfo?.cd_gp,
        cd_cust: searchInfo?.cd_cust,
        nm_cust_sort: searchInfo?.nm_cust_sort,
        // 입고형태(cd_io)는 의뢰적용 시 외주형태 입고유형(cd_io_isu)으로 채운다.
        // 신규 기본값을 출고코드(530)로 두면 입고형태 칸에 출고형태가 떠서 공란으로 둔다.
        cd_io: "",
        fg_io: "1",
        fg_money: "1",
        fg_trns: 1,
        cd_exch: "000",
        rt_exch: 1,
        fg_slip: "1",
        tp_slip: "8",
        yn_autoprocess: "N",
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow = () => {
    try {
      return gridRefs.current["grid2"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow2 = (): any => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const today = dateToString(new Date());
      const maxNoLine =
        gridRefs.current["grid2"].current.getMaxValue("no_line");
      return {
        cd_firm: focusedNodeH.data?.cd_firm,
        cd_biz: focusedNodeH.data?.cd_biz,
        no_io: focusedNodeH.data?.no_io,
        no_line: maxNoLine + 1,
        dt_io: today,
        dt_rtn_plan: today,
        fg_slip: "1",
        tp_slip: "8",
        cd_io: focusedNodeH.data?.cd_io,
        fg_io: focusedNodeH.data?.fg_io,
        fg_money: focusedNodeH.data?.fg_money,
        fg_map: focusedNodeH.data?.fg_map,
        yn_req: "Y",
        rt_exch: 1,
        no_line_order: 0,
        no_line_req: 0,
        qt: 0,
        qt_good: 0,
        qt_bad: 0,
        cd_wh: focusedNodeH.data.cd_wh,
        nm_wh: focusedNodeH.data.nm_wh,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onAddRow2 = () => {
    try {
      return gridRefs.current["grid3"].current?.addRow();
    } catch (error: any) {}
  };

  const onBeforeAddRow3 = (): any => {
    try {
      gridRefs.current["grid1"].current?.stopEditing();
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedNodeH == null) {
        showDialog("alter", "선택된 행이 없습니다.");
        return false;
      }

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const today = dateToString(new Date());
      const maxNoLine =
        gridRefs.current["grid3"].current.getMaxValue("no_line");
      return {
        cd_firm: focusedNodeH.data?.cd_firm,
        cd_biz: focusedNodeH.data?.cd_biz,
        no_io: focusedNodeH.data?.no_io,
        no_line: maxNoLine + 1,
        dt_io: today,
        dt_rtn_plan: today,
        cd_io: focusedNodeH.data?.cd_io,
        fg_io: focusedNodeH.data?.fg_io,
        fg_money: focusedNodeH.data?.fg_money,
        fg_map: focusedNodeH.data?.fg_map,
        fg_slip: "2",
        tp_slip: "8",
        yn_req: "Y",
        rt_exch: 1,
        no_line_order: 0,
        no_line_req: 0,
        qt: 0,
        qt_good: 0,
        qt_bad: 0,
      };
    } catch (error: any) {
      return false;
    }
  };

  const onDelete = async () => {
    if (gridRefs.current["grid1"].current?.getDisplayedRowCount() < 1) return;

    const confirm = await showDialog("confirm", "삭제하시겠습니까?");
    if (!confirm) return;

    let lineList: any[] = [];
    gridRefs.current["grid2"].current.forEachFilteredNode((node: RowNode) => {
      lineList.push(node);
    });
    for (const l of lineList) {
      if (l.data.qt_cls !== 0) {
        await showDialog("alter", "이미 마감된 건이 존재합니다.");
        return;
      }
    }

    gridRefs.current["grid3"].current.deleteAllRows();
    gridRefs.current["grid2"].current.deleteAllRows();
    gridRefs.current["grid1"].current.deleteSelectedRows();

    const realDeletedRows =
      gridRefs.current["grid1"].current.getChange().delete ?? [];
    if (Array.isArray(realDeletedRows) && realDeletedRows.length < 1) {
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      return;
    }

    return await onSave();
  };

  const onDeleteRow1 = async () => {
    const rowCount = gridRefs.current["grid2"].current?.getDisplayedRowCount();
    if (rowCount === 0) return;

    const focusedNodeL = gridRefs.current["grid2"].current?.focusedRowNode();
    if (focusedNodeL.data.qt_cls !== 0) {
      await showDialog("alter", "이미 마감된 건이 존재합니다.");
      return;
    }

    const deleteRcvNodes: any[] = [];
    gridRefs.current["grid3"].current.forEachFilteredNode((node: RowNode) => {
      if (node.data.cd_item_parent === focusedNodeL.data.cd_item) {
        deleteRcvNodes.push(node);
      }
    });
    for (const node of deleteRcvNodes)
      gridRefs.current["grid3"].current.deleteRowByIndex(node.rowIndex);

    gridRefs.current["grid2"].current?.deleteSelectedRows();
  };

  const onSave = async () => {
    try {
      gridRefs.current["grid1"].current.stopEditing();
      gridRefs.current["grid2"].current.stopEditing();
      gridRefs.current["grid3"].current.stopEditing();

      const requiredValuesCheckH =
        gridRefs.current["grid1"].current.requiredValuesCheck();
      if (!requiredValuesCheckH) return false;

      const requiredValuesCheckL1 =
        gridRefs.current["grid2"].current.requiredValuesCheck();
      if (!requiredValuesCheckL1) return false;

      const requiredValuesCheckL2 =
        gridRefs.current["grid3"].current.requiredValuesCheck();
      if (!requiredValuesCheckL2) return false;

      const qtioHChanges = gridRefs.current["grid1"].current.getChange();
      const qtioChanges1 = gridRefs.current["grid2"].current.getChange();
      const qtioChanges2 = gridRefs.current["grid3"].current.getChange();

      const headerInserts = qtioHChanges.insert ?? [];
      const lineInserts = qtioChanges1.insert ?? [];
      if (headerInserts.length > 0 && lineInserts.length === 0) {
        await showDialog(
          "alter",
          "상세 정보가 없습니다.\n행추가하여 상세정보 작성 후 저장해 주시기 바랍니다."
        );
        return false;
      }

      if (
        qtioHChanges.modifiedRowcount === 0 &&
        qtioChanges1.modifiedRowcount === 0
      ) {
        await showDialog("alter", "변경된 내용이 없습니다.");
        return false;
      }

      let hasInvalidcdItem = "";
      let hasInvalid = false;

      gridRefs.current["grid2"].current.forEachNode((node: RowNode) => {
        if (node.data.state === "insert") {
          if (node.data.qt_good + node.data.qt_bad !== node.data.qt) {
            if (!hasInvalid) {
              hasInvalid = true;
              hasInvalidcdItem = node.data.cd_item;
            }
          }
        }
      });

      if (hasInvalid) {
        await showDialog(
          "alter",
          "품목코드 [" +
            hasInvalidcdItem +
            "]의 양불수량과 입고량이 같지 않습니다."
        );
        return false;
      }

      for (const l of lineInserts) {
        if (
          l.yn_lot === "Y" &&
          (l.no_lot === null || l.no_lot === undefined || l.no_lot === "")
        ) {
          hasInvalid = true;
          break;
        }
      }
      if (hasInvalid) {
        await showDialog(
          "alter",
          "LOT관리 품목의 LOT번호가 입력되지 않았습니다."
        );
        return false;
      }

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      const lineDeletes = qtioChanges1.delete ?? [];
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (lineDeletes.length > 0 && rowCount === 0) {
        gridRefs.current["grid1"].current.deleteRowByIndex(
          focusedRowNodeH.rowIndex
        );
      }

      let noSlip: any;
      if (headerInserts.length > 0) {
        noSlip = await applyAutoSlip({
          cd_column: "no_io",
          cd_module: Menuprops.cd_module,
          no_line: 4,
          dt: focusedRowNodeH.data.dt_io,
          girdrefs: [gridRefs.current["grid1"], gridRefs.current["grid2"]],
          inserts: [qtioHChanges, qtioChanges1],
          cd_menu: Menuprops.cd_menu,
        });

        // 출고 데이터의 no_src, no_line_src에 입고 no_io, no_line 넣어주기
        gridRefs.current["grid3"].current?.forEachNode((node: any) => {
          if (node.data.no_io == "" || node.data.no_io == null) {
            node.setDataValue("no_src", noSlip);
          }
        });
        qtioChanges2.insert.forEach((row: any) => {
          if (row.no_io == "" || row.no_io == null) {
            row.no_src = noSlip;
          }
        });
      }

      const saveData = {
        qtioH: qtioHChanges,
        qtio: qtioChanges1,
        qtio2: qtioChanges2,
      };
      const ok = await fnSave("SN_MTL_SCT_REG_002_SAVE_01", saveData);
      if (!ok) {
        gridRefs.current["grid1"].current.resetUpdate(true);
        gridRefs.current["grid2"].current.resetUpdate(true);
        gridRefs.current["grid3"].current.resetUpdate(true);
        return false;
      }

      setFocusedIndex(focusedRowNodeH.rowIndex);
      gridRefs.current["grid1"].current.resetUpdate();
      gridRefs.current["grid2"].current.resetUpdate();
      gridRefs.current["grid3"].current.resetUpdate();
      await onSearch();
      return true;
    } catch (error: any) {
      gridRefs.current["grid1"].current.resetUpdate(true);
      gridRefs.current["grid2"].current.resetUpdate(true);
      gridRefs.current["grid3"].current.resetUpdate(true);
      return false;
    }
  };

  const onGrid1BtnsClick = async (id: string) => {
    if (id == "btnApply") {
      const qtioqHChanges =
        gridRefs.current["grid1"].current.getChange().insert;
      if (qtioqHChanges.length === 0) {
        await showDialog("alter", "신규행을 추가하시기 바랍니다.");
        return;
      }

      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      const searchInfo = searchRef.current.getFormdata();
      const selectedData = {
        cd_biz: searchInfo.cd_biz,
        cd_cust: focusedNodeH.data.cd_cust || searchInfo.cd_cust,
        nm_cust_sort: focusedNodeH.data.nm_cust_sort || searchInfo.nm_cust_sort,
        dt_from: searchInfo.dt_from,
        dt_to: searchInfo.dt_to,
      };

      const component = (
        <SN_MTL_SCT_REG_002_POP_001 selectedData={selectedData} />
      );
      const result = await showResizablePopupModal({
        title: "의뢰적용 도움",
        children: component,
        validation: true,
      });
      if (!result || result === "close") return;
      const headerResult = result[0];
      const lineResult = result[1];
      const lineResult2 = result[2];

      const focusedRowNodeH =
        gridRefs.current["grid1"].current.focusedRowNode();
      if (focusedRowNodeH && headerResult[0]) {
        focusedRowNodeH.setDataValue(
          "cd_cust",
          headerResult[0].cd_cust,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "nm_cust_sort",
          headerResult[0].nm_cust_sort,
          "noEvent"
        );
        focusedRowNodeH.setDataValue("cd_wh", lineResult[0].cd_wh, "noEvent");
        focusedRowNodeH.setDataValue("nm_wh", lineResult[0].nm_wh, "noEvent");
        // 입고형태 = 외주발주 외주형태의 입고유형. 팝업 헤더(rs0/rs2)가 mas_iotype(cd_io=cd_io_rcv)로
        // 조인해 내려주는 cd_io 를 그대로 쓴다. (cd_io_isu 는 불출/출고라 투입자재 라인 전용)
        focusedRowNodeH.setDataValue(
          "cd_io",
          headerResult[0].cd_io,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "fg_slip",
          headerResult[0].fg_slip,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "fg_money",
          headerResult[0].fg_money,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "fg_trns",
          headerResult[0].fg_trns,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "fg_vat",
          headerResult[0].fg_vat,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "cd_exch",
          headerResult[0].cd_exch,
          "noEvent"
        );
        focusedRowNodeH.setDataValue(
          "rt_exch",
          headerResult[0].rt_exch,
          "noEvent"
        );
      }
      const cdItemNoLineMap = new Map<string, any>();
      lineResult.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow();
          if (addedNode) {
            cdItemNoLineMap.set(result.cd_item, addedNode.data.no_line);
            addedNode.setDataValue("cd_item", result.cd_item, "noEvent");
            addedNode.setDataValue("nm_item", result.nm_item, "noEvent");
            addedNode.setDataValue(
              "dc_item_spec",
              result.dc_item_spec,
              "noEvent"
            );
            addedNode.setDataValue(
              "dc_item_unit",
              result.dc_item_unit,
              "noEvent"
            );
            addedNode.setDataValue("cd_io", headerResult[0].cd_io, "noEvent");
            addedNode.setDataValue(
              "fg_slip",
              headerResult[0].fg_slip,
              "noEvent"
            );
            addedNode.setDataValue(
              "fg_money",
              headerResult[0].fg_money,
              "noEvent"
            );
            addedNode.setDataValue("cd_wh", result.cd_wh, "noEvent");
            addedNode.setDataValue("nm_wh", result.nm_wh, "noEvent");
            addedNode.setDataValue("qt", result.qt_app, "noEvent");

            if (result.yn_qc === "Y") {
              // 검사결과 Y면 양품0 검사적용버튼 결과적용받음.
              addedNode.setDataValue("qt_good", 0, "noEvent");
            } else {
              addedNode.setDataValue("qt_good", result.qt_app, "noEvent");
            }

            addedNode.setDataValue("qt_cls", result.qt_cls, "noEvent");
            addedNode.setDataValue("um", result.um, "noEvent");
            addedNode.setDataValue("am", result.am, "noEvent");
            addedNode.setDataValue("um_k", result.um_k, "noEvent");
            addedNode.setDataValue("am_k", result.am_k, "noEvent");
            addedNode.setDataValue("am_vat", result.am_vat, "noEvent");
            addedNode.setDataValue("am_supply", result.am_supply, "noEvent");
            addedNode.setDataValue("um_supply", result.um_supply, "noEvent");
            addedNode.setDataValue("no_req", result.no_req, "noEvent");
            addedNode.setDataValue("no_line_req", result.no_line, "noEvent");
            addedNode.setDataValue("no_order", result.no_po, "noEvent");
            addedNode.setDataValue(
              "no_line_order",
              result.no_line_pol,
              "noEvent"
            );
            addedNode.setDataValue("dt_io", focusedNodeH.data.dt_io, "noEvent");
            addedNode.setDataValue("yn_lot", result.yn_lot, "noEvent");
            addedNode.setDataValue("no_lot", result.no_lot, "noEvent");
            addedNode.setDataValue("fg_trns", result.fg_trns, "noEvent");
            addedNode.setDataValue("fg_vat", result.fg_vat, "noEvent");
            addedNode.setDataValue("cd_exch", result.cd_exch, "noEvent");
            addedNode.setDataValue("rt_exch", result.rt_exch, "noEvent");
            addedNode.setDataValue("cd_pjt", result.cd_pjt, "noEvent");
            addedNode.setDataValue("nm_pjt", result.nm_pjt, "noEvent");

            addedNode.setDataValue("yn_qc", result.yn_qc, "noEvent");
            addedNode.setDataValue("st_qc", result.st_qc, "noEvent");
            addedNode.setDataValue("yn_confirm", result.yn_confirm, "noEvent");
            addedNode.setDataValue("qt_qc", result.qt_qc, "noEvent");
            addedNode.setDataValue("qt_qc_good", result.qt_qc_good, "noEvent");
            addedNode.setDataValue("qt_qc_bad", result.qt_qc_bad, "noEvent");
            addedNode.setDataValue("qt_qc_rcl", result.qt_qc_rcl, "noEvent");
          }
        }
      });
      lineResult2.map((result: any) => {
        if (headerResult[0]) {
          const addedNode = onAddRow2();
          if (addedNode) {
            addedNode.setDataValue(
              "no_line_src",
              cdItemNoLineMap.get(result.cd_item),
              "noEvent"
            );
            addedNode.setDataValue("cd_item_parent", result.cd_item, "noEvent");
            addedNode.setDataValue("nm_item_parent", result.nm_item, "noEvent");
            addedNode.setDataValue("cd_item", result.cd_matl, "noEvent");
            addedNode.setDataValue("nm_item", result.nm_matl, "noEvent");
            addedNode.setDataValue(
              "dc_item_spec",
              result.dc_item_spec_matl,
              "noEvent"
            );
            addedNode.setDataValue(
              "dc_item_unit",
              result.dc_item_unit_matl,
              "noEvent"
            );
            addedNode.setDataValue("cd_io", result.cd_io_isu, "noEvent");
            addedNode.setDataValue("fg_slip", result.fg_slip, "noEvent");
            addedNode.setDataValue("fg_money", result.fg_money, "noEvent");
            addedNode.setDataValue(
              "cd_wh",
              focusedNodeH.data.cd_cust,
              "noEvent"
            );
            addedNode.setDataValue("qt_need", result.qt_need, "noEvent");
            addedNode.setDataValue(
              "qt",
              result.qt_need * result.qt_app,
              "noEvent"
            );
            addedNode.setDataValue(
              "qt_good",
              result.qt_need * result.qt_app,
              "noEvent"
            );
            addedNode.setDataValue("qt_cls", result.qt_cls, "noEvent");
            addedNode.setDataValue("no_req", result.no_req, "noEvent");
            addedNode.setDataValue("no_line_req", result.no_line, "noEvent");
            addedNode.setDataValue("no_order", result.no_po, "noEvent");
            addedNode.setDataValue(
              "no_line_order",
              result.no_line_pol,
              "noEvent"
            );
            addedNode.setDataValue("dt_io", focusedNodeH.data.dt_io, "noEvent");
            addedNode.setDataValue("cd_pjt", result.cd_pjt, "noEvent");
            addedNode.setDataValue("nm_pjt", result.nm_pjt, "noEvent");
          }
        }
      });
      gridRefs.current["grid1"].current?.applyBlock(focusedRowNodeH);
    }
  };

  const onGrid2BtnsClick = async (id: string) => {
    if (id == "deleteRow") {
      onDeleteRow1();
    }
  };

  const onFocusedRowChanged = (event: any) => {
    const selectedRow = event;
    if (selectedRow) {
      const no_io = selectedRow.no_io;
      setSelectedDocu(no_io);
      gridRefs.current["grid3"].current.applyFilters({
        no_src: selectedRow.no_io,
      });
    }
  };

  const onCellValueChanged1 = async (event: CellValueChangedEvent) => {
    if (!event) return;
    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;

    switch (colId) {
      case "dt_io": {
        // 입고일자 변경 시 입고내역(grid2)·투입내역(grid3) 일자도 동일하게 맞춤.
        // 신규 입력 시 투입행 no_src는 저장 전까지 비어 필터에서 빠지므로 forEachNode로 전 행을 돌되,
        // 헤더 키(grid2=no_io, grid3=no_src)가 현재 전표(no_io)와 같은 행만 갱신한다.
        const noIo = rowData.no_io ?? "";
        gridRefs.current["grid2"].current.forEachNode((node: RowNode) => {
          if ((node.data.no_io ?? "") === noIo) {
            node.setDataValue("dt_io", rowData.dt_io, "noEvent");
          }
        });
        gridRefs.current["grid3"].current.forEachNode((node: RowNode) => {
          if ((node.data.no_src ?? "") === noIo) {
            node.setDataValue("dt_io", rowData.dt_io, "noEvent");
          }
        });
        break;
      }
      case "cd_cust":
        rowNode.setDataValue("cd_wh_ref", rowData.cd_cust);
        rowNode.setDataValue("cd_cust_dlv", rowData.cd_cust);
        break;
      case "cd_Wh":
        gridRefs.current["grid2"].current.forEachFilteredNode(
          (node: RowNode) => {
            node.setDataValue("cd_wh", rowData.cd_wh);
            node.setDataValue("nm_wh", rowData.nm_wh);
          }
        );
        break;
    }
  };

  const onCellValueChanged2 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();

    if (colId === "qt_good" || colId === "qt_bad") {
      rowNode.setDataValue("qt", rowData.qt_good + rowData.qt_bad);
    }
    if (colId === "qt") {
      gridRefs.current["grid3"].current.forEachFilteredNode((node: RowNode) => {
        if (node.data.cd_item_parent === rowData.cd_item) {
          node.setDataValue("qt_good", rowData.qt * node.data.qt_need);
        }
      });
    }
    if (colId === "cd_pjt") {
      const rowCount = gridRefs.current["grid2"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_pjt) return;

      let apply = false;
      gridRefs.current["grid2"].current?.forEachFilteredNode(
        (node: RowNode) => {
          if (
            node.data[colId] === "" ||
            node.data[colId] === null ||
            node.data[colId] === undefined
          )
            apply = true;
        }
      );
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );

      if (confirm) {
        gridRefs.current["grid2"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_pjt === "" ||
              node.data.cd_pjt === null ||
              node.data.cd_pjt === undefined
            ) {
              node.setDataValue("cd_pjt", rowData.cd_pjt);
              node.setDataValue("nm_pjt", rowData.nm_pjt);
            }
          }
        );
      }
    }
    await CalAm(gridRefs.current["grid1"], gridRefs.current["grid2"], colId);
  };

  const onCellValueChanged3 = async (event: CellValueChangedEvent) => {
    if (!event) return;

    const colId = event.colId;
    const rowData = event.rowData;
    const rowNode = event.rowNode;
    const focusedRowNodeL = gridRefs.current["grid2"].current.focusedRowNode();

    if (colId === "qt_good" || colId === "qt_bad") {
      rowNode.setDataValue("qt", rowData.qt_good + rowData.qt_bad);
    }
    if (colId === "cd_pjt") {
      const rowCount = gridRefs.current["grid3"].current.getDisplayedRowCount();
      if (rowCount === 1) return;
      if (!rowData.cd_pjt) return;

      let apply = false;
      gridRefs.current["grid3"].current?.forEachFilteredNode(
        (node: RowNode) => {
          if (
            node.data[colId] === "" ||
            node.data[colId] === null ||
            node.data[colId] === undefined
          )
            apply = true;
        }
      );
      if (!apply) return;

      const confirm = await showDialog(
        "confirm",
        "일괄적용하시겠습니까?(비어있는 칸이 채워집니다.)"
      );

      if (confirm) {
        gridRefs.current["grid3"].current?.forEachFilteredNode(
          (node: RowNode) => {
            if (
              node.data.cd_pjt === "" ||
              node.data.cd_pjt === null ||
              node.data.cd_pjt === undefined
            ) {
              node.setDataValue("cd_pjt", rowData.cd_pjt);
              node.setDataValue("nm_pjt", rowData.nm_pjt);
            }
          }
        );
      }
    }
  };

  const onRowDataReady = () => {
    if (focusedIndex) {
      gridRefs.current["grid1"].current.selectAndFocusRow(focusedIndex);
    }
  };

  //#region onSnButtonClick
  const onSnButtonClick = async (id: string) => {
    const focusedRowNodeH = gridRefs.current["grid1"].current.focusedRowNode();
    if (!focusedRowNodeH) {
      return;
    }

    if (focusedRowNodeH.data.state !== "insert") {
      return;
    }

    switch (id) {
      case "Qc":
        let hasInvalid = false;

        gridRefs.current["grid2"].current.forEachFilteredNode(
          (node: RowNode) => {
            if (node.data.yn_qc === "Y" && node.data?.st_qc !== "C") {
              hasInvalid = true;
            }

            if (
              node.data.yn_qc === "Y" &&
              node.data.st_qc === "C" &&
              node.data.qt === node.data.qt_qc
            ) {
              switch (node.data.yn_confirm) {
                case "Y": // 합격
                  node.setDataValue(
                    "qt_good",
                    node.data.qt_qc - node.data.qt_qc_bad,
                    "noEvent"
                  );
                  node.setDataValue("qt_bad", node.data.qt_qc_bad, "noEvent");
                  node.setDataValue("qt_rcv", node.data.qt_qc, "noEvent");
                  break;
                case "N": // 불합격
                  node.setDataValue("qt_bad", node.data.qt_qc, "noEvent");
                  node.setDataValue("qt_rcv", node.data.qt_qc, "noEvent");
                  break;
                case "R": // 특채
                  node.setDataValue("qt_good", node.data.qt_qc_rcl, "noEvent");
                  node.setDataValue("qt_bad", node.data.qt_qc_bad, "noEvent");
                  node.setDataValue("qt_rcv", node.data.qt_qc, "noEvent");
                  break;
              }
            }
          }
        );

        if (hasInvalid) {
          await showDialog("alter", "검사가 발송되지 않은 건이 존재합니다.");
        }
        break;
    }
  };
  //#endregion

  const grids = useMemo(
    () => ({
      grid1: {
        columns: columns.grid1,
        dataSource: dataSources.grid1,
        events: {
          onFocusedRowChanged,
          onCellValueChanged: onCellValueChanged1,
          onBeforeAddRow: onBeforeAddRow1,
          onRowDataReady: onRowDataReady,
        },
      },
      grid2: {
        columns: columns.grid2,
        dataSource: dataSources.grid2,
        events: {
          onBeforeAddRow: onBeforeAddRow2,
          onBtnDeleteClick: onGrid2BtnsClick,
          onCellValueChanged: onCellValueChanged2,
        },
      },
      grid3: {
        columns: columns.grid3,
        dataSource: dataSources.grid3,
        events: {
          onBeforeAddRow: onBeforeAddRow3,
          onCellValueChanged: onCellValueChanged3,
        },
      },
    }),
    [columns, dataSources]
  );

  return (
    <div className="h-full flex flex-col">
      <div className="mb-1">
        <SearchPanel
          ref={searchRef}
          data={formData}
          controls={formControlData}
        ></SearchPanel>
      </div>

      <div className="flex-1 h-full min-h-0 space-y-1.5">
        <SnResizeBar direction={"height"} id="panel1" orgSize="45.5%">
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{ rowSelection: "single", title: "입고정보" }}
            events={grids.grid1.events}
            header={
              <div>
                <SnButton
                  text={"의뢰적용"}
                  onClick={() => {
                    onGrid1BtnsClick("btnApply");
                  }}
                />
              </div>
            }
            filter={{
              refs: [gridRefs.current["grid2"]],
              columns: ["no_io"],
            }}
          />
        </SnResizeBar>
        <SnResizeBar direction={"height"} id="panel2" orgSize="45.5%">
          <SnTab
            titles={["입고내역", "투입내역"]}
            width={"100%"}
            header={[
              <SnTabHeader
                onBtnDeleteClick={onGrid2BtnsClick}
                body={
                  <div>
                    <SnButton
                      text={"검사적용"}
                      onClick={() => {
                        onSnButtonClick("Qc");
                      }}
                    />
                  </div>
                }
              />,
              <SnTabHeader />,
            ]}
            body={[
              <SnGrid
                ref={gridRefs.current["grid2"]}
                columnConfig={grids.grid2.columns}
                rowData={grids.grid2.dataSource}
                etcProps={{ rowSelection: "single" }}
                events={grids.grid2.events}
              />,
              <SnGrid
                ref={gridRefs.current["grid3"]}
                columnConfig={grids.grid3.columns}
                rowData={grids.grid3.dataSource}
                etcProps={{ rowSelection: "multiple" }}
                events={grids.grid3.events}
              />,
            ]}
          />
        </SnResizeBar>
        <SnFileUploadBox selectedDocu={selectedDocu} selectedLineDocu={0} />
      </div>
    </div>
  );
});

export default SN_MTL_SCT_REG_002;
